module.exports = __webpack_public_path__ + "static/media/010.614c9681.jpg";